<template>
  <v-row>
    <v-col
      cols="12"
      class="text-h5 font-weight-bold"
    >
      User Details
    </v-col>
    <v-col cols="12">
      <v-btn
        text
        @click="back"
      >
        &lt; Back
      </v-btn>
    </v-col>
    <template v-if="!loading">
      <v-col
        cols="12"
        sm="5"
      >
        <UserCard />
      </v-col>
      <v-col
        cols="12"
        sm="7"
      >
        <UserLists />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import UserCard from '@/components/users/detail/card/Index';
import UserLists from '@/components/users/detail/lists/Index';
import { mapGetters } from 'vuex';
export default {
  name: 'UsersDetail',
  components: { UserCard, UserLists },
  data() {
    return {
      loading: true,
      tabs: [
        { id: '/users', name: 'Users' },
        { id: '/users/contributors', name: 'Contributors' }
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapGetters({ user: 'users/user' })
  },
  async mounted() {
    this.loading = true;
    this.$store
      .dispatch('users/get', this.id)
      .then(() => {
        const calls = [
          this.$store.dispatch('users/getOrders', this.id),
          this.$store.dispatch('users/getProjects', this.id),
          this.$store.dispatch('lookup/getCategories')
        ];
        if (this.user.isContributor) {
          calls.push(this.$store.dispatch('users/getPayouts', this.id));
        }
        Promise.all(calls);
      })
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });

    // await Promise.all([
    //   this.$store.dispatch("lookup/getCategories"),
    //   this.$store.dispatch("lookup/getDesignGroups"),
    //   this.$store.dispatch("lookup/getDesigners"),
    //   this.$store.dispatch("lookup/getProducts")
    // ]);
  }
};
</script>
